import React from 'react'
import { useIntl } from 'react-intl'
import { useRecoilValue, useResetRecoilState } from 'recoil'
import {
  Button,
  Modal,
  ModalBody,
  Title,
  ModalFoot,
  Text,
  SpacingVertical,
  Link
} from 'mailup-web-components'
import modalContentDefaultsIcon from './content-defaults-icon-upgrade.svg'
import {
  evalCondition,
  notifyParent,
  storeGet,
  STORE_KEY_ACCOUNT,
  getLang
} from 'mailup-react-helpers'
import styled from '@emotion/styled'
import { modalContentsDefaultsState } from 'Components/ModalContentDefaults/recoil/state'

const StyledIcon = styled.img`
  height: 85px;
  width: 85px;
`

const StyledTitle = styled(Title)`
  text-align: center;
`

const StyledText = styled(Text)`
  text-align: center;
`
const StyledDiv = styled.div`
  text-align: center;
`
const StyledModal = styled(Modal)`
  .b-modal__foot {
    justify-content: center !important;
  }
`

const ModalContentDefaults = () => {
  const intl = useIntl()
  const { show } = useRecoilValue(modalContentsDefaultsState)
  const resetModal = useResetRecoilState(modalContentsDefaultsState)
  const lang = getLang()
  const account = storeGet(STORE_KEY_ACCOUNT)
  const showMshop = evalCondition(
    'uo:GEST AND NOT c:IsRetailer AND NOT c:IsDeveloper AND NOT co:TURNOFFMSHOP'
  )

  const bandOrFreqConsole = account.IdOffer === 1 || account.IdOffer === 2

  const handleClose = () => {
    resetModal()
  }

  const handleReadMore = () => {
    if (lang === 'it') {
      window
        .open(
          'https://help.mailup.com/display/MM/Stili+personalizzati',
          '_blank',
          'noopener,noreferrer'
        )
    } else if (lang === 'es') {
      window
        .open(
          'https://help.mailup.com/display/MMES/Estilos+personalizados',
          '_blank',
          'noopener,noreferrer'
        )
    } else {
      window
        .open('https://help.mailup.com/display/MUG/Content+Defaults', '_blank','noopener,noreferrer')
    }
  }

  const goToMshop = () => {
    notifyParent('redirectMainFrame', ['mshop_Redirector.aspx?t=mshopem'])
  }

  return (
    <StyledModal
      show={show}
      showClose
      closeOnOverlayClick={false}
      onClose={handleClose}
      data-mu-test='modal-message-edit-error'
    >
      <ModalBody>
        <StyledDiv>
          <StyledIcon src={modalContentDefaultsIcon} />
        </StyledDiv>
        <SpacingVertical variant='8' />
        <StyledTitle>
          {intl.formatMessage({ id: 'Load.ContentDefaults.UpgradeModalTitle' })}
        </StyledTitle>
        <SpacingVertical />
        {showMshop && !bandOrFreqConsole && (
          <StyledText>
            {intl.formatMessage({
              id: 'Load.ContentDefaults.UpgradeModalBody'
            })}
          </StyledText>
        )}
        {(!showMshop || bandOrFreqConsole) && (
          <StyledText>
            {intl.formatMessage(
              {
                id: 'Load.ContentDefaults.UpgradeModalBodyNoMshop'
              },
              {
                link: e => (
                  <Link variant='highlight' href={'mailto:' + e}>
                    {e}
                  </Link>
                )
              }
            )}
          </StyledText>
        )}
      </ModalBody>

      <ModalFoot>
        <Button onClick={handleReadMore} kind='secondary'>
          {intl.formatMessage({
            id: 'Load.ContentDefaults.ReadMore'
          })}
        </Button>
        {showMshop && !bandOrFreqConsole && (
          <Button onClick={goToMshop} kind='primary'>
            {intl.formatMessage({
              id: 'Load.ContentDefaults.UpgradeModalBuy'
            })}
          </Button>
        )}
      </ModalFoot>
    </StyledModal>
  )
}

export default ModalContentDefaults
